<template>
  <div>
    <MakeBankRequest :companyId="company" :branches="branches" />
    <UpdateBankAcctRequest
      :details="editDetails"
      :companyId="company"
      :branches="branches"
    />
    <MasterLayout>
      <div class="dashboard_first_row pt-4 pb-3 pl-4 pr-4">
        <div class="row align-items-center white-bg py-3">
          <div class="col-md-1 remove-right-padding col-center-flex">
            <div class="square-icon-wrapper small sky-bg">
              <img src="@/assets/img/bank-building (2).svg" width="35" />
            </div>
          </div>
          <div class="col-md-7">
            <div class="d-flex flex-column flex-md-row flex-lg-row">
              <div>
                <h4 class="primary-color font-600">
                  {{ $t("text.cMasterLayout.bankAcctRequest") }}
                </h4>
                <p class="light-grey-text mt-3">
                  {{ $t("text.cBank.bankAcctRequestDesc") }}
                </p>
              </div>

              <div class="ml-lg-5 ml-md-5">
                <button
                  class="w-100 px-5 py-3 mb-2 rounded text-white"
                  style="background-color: #4b2d73; border: none"
                  @click="makeRequest"
                >
                  {{ $t("text.cBank.makeRequest") }}
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3 border rounded">
              <vue-ctk-date-time-picker
                v-model="dateRange"
                :max-date="maxDate"
                :range="true"
                :autoClose="true"
                :locale="this.$root.$i18n.locale"
                :custom-shortcuts="customShortcuts"
                color="#4b2d73"
                format="DDMMYYYY"
                formatted="DD/MM/YYYY"
                :label="$t('text.calendar.dateRange')"
              />
            </div>

            <div class="mb-3">
              <label class="">
                {{ $t("text.actionButtons.status") }}
              </label>
              <select v-model="selectStatus">
                <option selected value="selectStatus">
                  {{ $t("text.cBranchReport.all") }}
                </option>
                <option value="approved">
                  {{ $t("text.bSettlement.approved") }}
                </option>
                <option value="denied">
                  {{ $t("text.cBank.declined") }}
                </option>
                <option value="reverted">
                  {{ $t("text.reorderLevel.reverted") }}
                </option>
                <option value="pending">
                  {{ $t("text.fundWalletRequest.pending") }}
                </option>
              </select>
            </div>

            <div>
              <label class="">
                {{ $t("text.clickButtons.branches") }}
              </label>
              <select v-model="selectedBranch">
                <option selected value="">
                  {{ $t("text.cBranchReport.all") }}
                </option>
                <option
                  :value="branch.id"
                  v-for="(branch, index) in branches"
                  :key="index"
                >
                  {{ branch.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="new-row"></div>

      <section class="new-row mt-3">
        <ejs-grid
          v-show="!showLoader"
          ref="dataGrid"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :toolbar="toolbar"
          :searchSettings="search"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :allowTextWrap="true"
          :rowDataBound="rowDataBound"
          :excelQueryCellInfo="excelQueryCellInfo"
          :locale="usedLang"
        >
          <e-columns>
            <e-column width="50" field="index" headerText="#"></e-column>

            <e-column
              width="250"
              field="date"
              :headerText="$t('text.manageExpenses.date')"
            ></e-column>
            <e-column
              width="220"
              field="company"
              :headerText="$t('text.branch.company')"
            ></e-column>
            <e-column
              width="220"
              field="branch"
              :headerText="$t('text.categories.branch')"
            ></e-column>
            <e-column
              width="350"
              field="bankName"
              :headerText="$t('text.bankAccounts.bank')"
            ></e-column>
            <e-column
              width="250"
              field="accountName"
              :headerText="$t('text.cBank.accountName')"
            ></e-column>
            <e-column
              width="250"
              field="accountNumber"
              :headerText="$t('text.bBankAccounts.accountNumber')"
            ></e-column>
            <e-column
              width="200"
              field="bankCode"
              :headerText="$t('text.bBankAccounts.bankCode')"
            ></e-column>
            <e-column
              width="200"
              field="accountType"
              :headerText="$t('text.drivers.accountType')"
            ></e-column>
            <e-column
              width="200"
              field="status"
              :headerText="$t('text.actionButtons.status')"
            ></e-column>
            <e-column
              width="250"
              :template="actionTemplate"
              :headerText="$t('text.products.action')"
            ></e-column>
          </e-columns>
        </ejs-grid>
        <TableLoader :showLoader="showLoader"></TableLoader>
      </section>
    </MasterLayout>
  </div>
</template>
<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import MakeBankRequest from "@/components/modals/MakeBankRequest";
import ActionTemplate from "@/components/Templates/BankAcctRequest/companyTemplate.vue";
import UpdateBankAcctRequest from "@/components/modals/MakeBankRequest/UpdateBankAcctRequest.vue";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import Paginator from "@/components/Paginator.vue";
import Jquery from "jquery";
import { defined } from "highcharts";
let $ = Jquery;

export default {
  title: "Bank Account Request :: Epump Portal",
  components: {
    MasterLayout,
    TableLoader,
    Paginator,
    TableLoader,
    MakeBankRequest,
    UpdateBankAcctRequest,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      selectStatus: "selectStatus",
      bankNames: [],
      branches: [],
      editDetails: null,
      selectedBranch: "",
      searchTerm: "",
      formatOptions: { type: "date", format: "dd/MM/yyyy " },
      branchId: null,
      showLoader: true,
      company: null,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      startDate: this.$moment().subtract(30, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(30, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      actionTemplate: function () {
        return {
          template: ActionTemplate,
        };
      },
    };
  },

  watch: {
    selectedBranch(branch) {
      if (branch !== null) {
        this.selectStatus = "selectStatus";
        this.getBankAcctRequest();
      }
    },

    selectStatus(status) {
      if (status !== null) {
        this.getBankAcctRequest();
      }
    },
    company(company) {
      if (company !== null) {
        this.getBankAcctRequest();
        this.getBranches();
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.selectStatus = "selectStatus";
        this.getBankAcctRequest();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });

    if (this.$route.query.companyId) {
      this.getBankAcctRequest();
      this.getBranches();
    }

    this.$eventHub.$on("getBankRequest", this.getBankAcctRequest);
    this.$eventHub.$on("openCompanyEditModal", (data) => {
      this.editDetails = data;
      this.$modal.show("updateCompanyBankRequest");
    });

    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
  },
  beforeDestroy() {
    this.$eventHub.$off("getBankRequest");
    this.$eventHub.$off("openCompanyEditModal");
  },
  mounted() {},
  methods: {
    makeRequest() {
      this.$modal.show("makeRequest");
    },

    getBankAcctRequest() {
      this.showLoader = true;
      let url;
      url = `${
        configObject.apiBaseUrl
      }/BankAccountRequest/AccountRequests?startDate=${
        this.startDate
      }&endDate=${this.endDate}&CompanyId=${
        this.$route.query.companyId
          ? this.$route.query.companyId
          : this.company.id
      }&BranchId=${this.selectedBranch ? this.selectedBranch.id : ""}&status=${
        this.selectStatus == "selectStatus" ? "" : this.selectStatus
      }`;

      this.axios
        .get(url, configObject.authConfig())
        .then((res) => {
          let index = 0;

          res.data.forEach((el) => {
            el.index = ++index;
            el.date = this.$moment(el.date).format(" MMMM Do, YYYY h:mm a");
            // el.isApproved = el.isApproved ? "APPROVED" : "UNAPPROVED";

            // translating the status
            if (el.status == "Approved") {
              el.status = this.$t("text.bSettlement.approved");
            } else if (el.status == "Denied") {
              el.status = this.$t("text.cBank.declined");
            } else if (el.status == "Pending") {
              el.status = this.$t("text.fundWalletRequest.pending");
            } else {
              el.status = this.$t("text.reorderLevel.reverted");
            }
            el.status = el.status.toUpperCase();

            if (el.branch == null) {
              el.branch = "N/A";
            }
          });

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data,
          });
          this.refreshGrid();
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getBranches() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Branches/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });
          this.branches = res.data;
        })
        .catch((error) => {});
    },
    excelQueryCellInfo(args) {
      if (args.column.field == "dateLinked") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    rowDataBound: function (args) {
      // args.row.cells[9].toUpperCase();
      if (
        args.data["status"] == this.$t("text.cBank.declined").toUpperCase() ||
        args.data["status"] ==
          this.$t("text.reorderLevel.reverted").toUpperCase()
      ) {
        args.row.cells[9].style.color = "red";
      } else if (
        args.data["status"] ==
        this.$t("text.fundWalletRequest.pending").toUpperCase()
      ) {
        args.row.cells[9].style.color = "gold";
      } else {
        args.row.cells[9].style.color = "green";
      }
    },

    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
